import script from "./brand-referral-bonus.vue?vue&type=script&setup=true&lang=js"
export * from "./brand-referral-bonus.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__